import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { brand, BrandManipulationViewModel } from "./brandManipulation-viewModel"

export class BrandManipulationView extends View<BrandManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-91A2FCF1-3F50-4A6D-BC0E-07BF4C4C1AEA"
    }
    loadHtml(): string {
        let element = require('./brandManipulation.html').default;
        let style = require('./brandManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set brands(v: ObservableArray<brand>) { this._brands = v; } public get brands(): ObservableArray<brand> { return this._brands;} private _brands: ObservableArray<brand>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestBrandCreation(){
        this.dataContext.requestBrandCreation();
    }
}
